import { PREACTIVATE_SIM, VERIFY_PREACTIVATION, VERIFY_NECT_PREACTIVATION, GET_NECT_PREACTIVATION_LIST, CAPTURE_NECT_PREACTIVATION,  GET_PREACTIVATION_LIST, SIM_BUNDLE_MAP, GET_SIM_BUNDLE_LIST, GET_SIM_TRACKING_LIST, DELETE_BUNDLE_MAPPING, DELETE_PREACTIVATION  } from 'redux/admin-constants';

const initialState = { 
  simPreactivationDetails:{},
  verificationData:{},
  preactivationListData:{},
  simBundleListData:[],
  simTrackingData:[]
}

const reducer = (state = initialState,  action) => {
const {
  type,
  payload
} = action;

switch (type) {

  case PREACTIVATE_SIM: {
    return {
      ...state,
      simPreactivationDetails: payload,
    }
  }

  case CAPTURE_NECT_PREACTIVATION: {
    return {
      ...state,
      simPreactivationDetails: payload,
    }
  }

  case VERIFY_PREACTIVATION: {
    return {
      ...state,
      verificationData: payload,
    }
  }

  case VERIFY_NECT_PREACTIVATION: {
    return {
      ...state,
      verificationData: payload,
    }
  }

  case GET_PREACTIVATION_LIST: {
    return {
      ...state,
      preactivationListData: payload,
    }
  }

  case GET_NECT_PREACTIVATION_LIST: {
    return {
      ...state,
      preactivationListData: payload,
    }
  }
    case SIM_BUNDLE_MAP: {
    return {
      ...state,
      simBundleListData: [payload, ...state.simBundleListData],
    }
  }

   case GET_SIM_BUNDLE_LIST: {
    return {
      ...state,
      simBundleListData: payload,
    }
  }

    case GET_SIM_TRACKING_LIST: {
    return {
      ...state,
      simTrackingData: payload,
    }
  }

  default:
    return state;
  }
}

export default reducer;